var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeIcon = function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    stroke: "#999",
    strokeWidth: 0.2,
    d: "M9.5 1c3.66 0 6.907 1.87 8.922 4.753a.421.421 0 0 1 0 .488C16.407 9.124 13.16 11 9.5 11 5.84 11 2.593 9.124.578 6.24a.422.422 0 0 1 0-.487C2.593 2.87 5.84 1 9.5 1Zm0 .833C6.221 1.833 3.316 3.465 1.434 6c1.882 2.533 4.789 4.167 8.066 4.167 3.277 0 6.184-1.634 8.066-4.167-1.882-2.535-4.787-4.167-8.066-4.167Zm0 1.25c1.576 0 2.863 1.311 2.863 2.917 0 1.606-1.287 2.917-2.863 2.917-1.577 0-2.863-1.311-2.863-2.917 0-1.606 1.286-2.917 2.863-2.917Zm0 .834c-1.134 0-2.045.927-2.045 2.083 0 1.156.91 2.083 2.045 2.083 1.134 0 2.045-.927 2.045-2.083 0-1.156-.91-2.083-2.045-2.083Z"
  })));
};
export default SvgEyeIcon;